module.exports = __webpack_public_path__ + "img/LogoExos_Color.7e31ae13.png";